module.exports = __webpack_public_path__ + "static/media/hero.d4e30671.png";